import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import logo from "../../assets/gramagec-logo.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { href: "#accueil", label: "Accueil" },
    { href: "#apropos", label: "À Propos" },
    { href: "#projets", label: "Projets" },
    { href: "#services", label: "Services" },
    { href: "#clients", label: "Clients" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-card/95 backdrop-blur-md shadow-lg py-3"
          : "bg-transparent py-5"
      }`}>
      <div className="container-custom flex items-center justify-between px-4 md:px-8">
        <a href="accueil" className="flex items-center gap-3">
          <img src={logo} alt="logo" width={150} />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`font-medium transition-colors hover:text-secondary ${
                isScrolled ? "text-foreground" : "text-primary-foreground"
              }`}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="#contact"
            className="inline-flex items-center justify-center h-11 px-8 rounded-md bg-gradient-to-r from-secondary to-amber-600 text-primary-foreground font-semibold shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all">
            Demander un devis
          </a>
        </div>
        <button
          className="lg:hidden p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu">
          {isMobileMenuOpen ? (
            <X
              className={`w-6 h-6 ${isScrolled ? "text-foreground" : "text-primary-foreground"}`}
            />
          ) : (
            <Menu
              className={`w-6 h-6 ${isScrolled ? "text-foreground" : "text-primary-foreground"}`}
            />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-card border-t border-border">
          <nav className="container-custom py-4 px-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-medium text-foreground hover:text-secondary py-2"
                onClick={() => setIsMobileMenuOpen(false)}>
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="mt-2 inline-flex items-center justify-center h-10 px-6 rounded-md bg-gradient-to-r from-secondary to-amber-600 text-primary-foreground font-semibold shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all">
              Demander un devis
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
